import DisbursementReport from "../../../jsx/components/Dashboard/DisbursementReport/DisbursementReport";

const DisbursementReportsWrapper = () => {
  return <DisbursementReport />;
};

export default constore(DisbursementReportsWrapper);
